import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CrmdealskanbanRoutingModule } from './crmdealskanban-routing.module';
import { CrmdealskanbanComponent } from './crmdealskanban.component';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { KanbanleadstatusComponent } from './kanbanleadstatus/kanbanleadstatus.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconModule } from '@visurel/iconify-angular';
@NgModule({
  declarations: [
    CrmdealskanbanComponent,
    KanbanleadstatusComponent
  ],
  imports: [
    CommonModule,
    // BrowserModule,
    // BrowserAnimationsModule,
    CustomFlexLayoutModule,
    MatCardModule,
    DragDropModule,
    SharedModule,
    CrmdealskanbanRoutingModule,
    IconModule
  ],
  exports: [ CrmdealskanbanComponent ]
})
export class CrmdealskanbanModule { }
